import { WindowTitle } from "@saleor/components/WindowTitle";
import { OrderDraftField } from "@saleor/graphql";
import { sectionNames } from "@saleor/intl";
import { SaveDraftListQueryParam } from "@saleor/saveDraft/urls";
import { asSortParams } from "@saleor/utils/sort";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, RouteComponentProps, Switch } from "react-router";

import { saveDraftUrl } from "./urls";
import SaveDraftView from "./views/SaveDraftView";

const SaveDraftSection = () => {
  const intl = useIntl();

  const SaveDraftComponent: React.FC<RouteComponentProps<any>> = () => {
    const qs = parseQs(location.search.substr(1));

    const params: SaveDraftListQueryParam = asSortParams(
      qs,
      OrderDraftField,
      OrderDraftField.UPDATED_AT
    );
    return <SaveDraftView params={params} />;
  };

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.saveDraft)} />
      <Switch>
        <Route exact path={saveDraftUrl} render={SaveDraftComponent} />
      </Switch>
    </>
  );
};

export default SaveDraftSection;
